import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Input, Select, DatePicker } from 'antd';
import SearchMulSelect from '../../common/SearchMulSelect';
import SelectProvince from '../../common/SelectProvince';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import fp from '../../../utils/fp';
import moment from 'moment';

const Option = Select.Option;

class Filter extends Component {
    constructor(props) {
        super(props);
        const { feedBack, searchParams } = this.props;
        this.state = {
            areaList: [],
            diseaseList: [],
            businessList: [],
            hospitalOptions: [],
            searchParams: feedBack ? searchParams : {},
            CourtyardAreaList: [],
            needCourtyardArea: false, //院区必填判断
            obj: {},
            yearMonthList: [],
        }
    }

    componentDidMount() {
        const { params, searchParams } = this.props;
        this.setState({
            searchParams:{
                ...params,
                ...searchParams,
            }
        },() => this.queryCourtyardAreaList())
        this.search();
        this.loadAreaList();
        this.queryWithLevelByParams();
        this.loadYearMonthList();
    }

    /**
     * 加载已固化的年月列表，默认选中当前年月
     */
    loadYearMonthList = () => {
        $.sendRequest({
            method: 'POST',
            url: `${API_URL.hospital.queryHospitalDeptDataRecordYearMonth}`,
            data: {},
            dataType: 'json',
            doneResult: res => {
                if (res && res.yearMonthList) {
                    const now = moment();
                    const curYearMonth = parseInt(now.format('YYYYMM'));
                    const list = res.yearMonthList || [];
                    if (list.indexOf(curYearMonth) === -1) {
                        list.unshift(curYearMonth);
                    }
                    this.setState(prevState => ({
                        yearMonthList: list,
                        searchParams: {
                            ...prevState.searchParams,
                            date: now.format('YYYY-MM'),
                        },
                    }));
                }
            },
        });
    }

    /**
     * 时间选择变更
     */
    handleMonthChange = (date, dateString) => {
        const { searchParams } = this.state;
        searchParams.date = dateString;
        this.setState({ searchParams });
    }

    /**
     * 禁用不在 yearMonthList 中的月份（仅可选择已固化年月 + 当前年月）
     */
    disabledDate = (current) => {
        if (!current) return false;
        const { yearMonthList } = this.state;
        const currentYearMonth = parseInt(current.format('YYYYMM'));
        return yearMonthList.indexOf(currentYearMonth) === -1;
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search(searchParams);
    }

    enterSearch = e => {
        if (e.charCode == 13) {
            this.search();
        }
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: `${API_URL.common.queryAllInvestigationArea}`,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ areaList: res.data }, () => {
                const { searchParams: { investigationAreaId }} = this.state;
                investigationAreaId && this.loadDiseaseList(investigationAreaId);
            });
        });
    }

    loadDiseaseList = investigationAreaId => {
        dictCache.getDict(`DISEASE_AREA_${investigationAreaId}`, cb => {
            $.sendRequest({
                method: 'POST',
                url: `${API_URL.common.queryAllDisease}`,
                data: { investigationAreaId },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            if (!res.error) {
                this.setState({ diseaseList: res.data });
            }
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        const params = {};
        searchParams[field] = value;
        if (field == 'investigationAreaId') {
            params.diseaseList = [];
            searchParams.diseaseId = undefined;
        } else if (field === 'lineOfBusiness') {
            searchParams.secondLineName = undefined;
        } else if (field === 'courtyardArea') {
            searchParams.courtyardArea = value;
        }
        this.setState({
            ...params,
            searchParams,
        }, () => {
            if (field == 'investigationAreaId' && value) {
                this.loadDiseaseList(value);
            }
        });
    }

    handleUserChange = (value, key) =>{
        const { searchParams } = this.state;
        const {value: id, text: name} = value;
        searchParams[`${key}Id`] = id;
        searchParams[`${key}Name`] = name;
        if(key === 'user'){searchParams.jsChargeUserId = id}
        this.setState({
            searchParams,
        })
    }

    parseHospitalData = res => {
        if ((res.data || res.datas)) {
            const sourceData = res.data || res.datas;
            const data = sourceData.map(item => ({
                text: `${item.hospitalName}`,
                value: item.hospitalId,
                fetching: false,
            }));
            this.setState({ hospitalOptions: data });
        } else {
            this.setState({ hospitalOptions: [] });
        }
    }

    hospitalSelectChange = value => {
        const { searchParams = {} } = this.state;
        searchParams.hospitalMainId = value.value;
        searchParams.hospitalMainName = value.text;
        searchParams.courtyardArea = undefined;
        this.setState({ searchParams },() => this.state.searchParams.hospitalMainId && this.queryCourtyardAreaList());
    }

    courtyardAreaSelectChange = (value) => {
        const {searchParams} = this.state;
        searchParams.courtyardArea = value;
        this.setState({
            searchParams:{
                ...searchParams,
            }
        })
    }

    queryCourtyardAreaList = () => {
        const { searchParams: { hospitalMainId } } = this.state;
        if (hospitalMainId) {
            const options = {
                method: 'POST',
                url: API_URL.hospital.queryHospitalCourtyardAreaList,
                data: {    
                    hospitalMainId,
                },
                dataType: 'json',
                doneResult: res => {
                    const { datas } = res;
                    let { needCourtyardArea } = this.state;
                    needCourtyardArea = false;
                    datas.map(i=>{
                        if (i.courtyardArea) {
                            needCourtyardArea = true;
                        }
                    })
                    this.setState({ CourtyardAreaList: datas, needCourtyardArea });
                }
            };
            $.sendRequest(options);
        }
    }

    saveProvince = (checkedArea) => {
        const { searchParams } = this.state;
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.setState({
            searchParams: {
                ...searchParams,
                areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        });
    }

    render() {
        const { isAdd, crcFlag } = this.props;
        const { areaList, diseaseList, searchParams, hospitalOptions, businessList, CourtyardAreaList, needCourtyardArea, yearMonthList } = this.state;
        const { hospitalMainId, hospitalMainName, departmentName, investigationAreaId, diseaseId, isMyResponsibleHospital, cityManagerFilter, isMyResponsibleDepartment, areaName, hasCheckedArea = [], isCooperation, isRequestFromSite, centerPharmacy, unblindingRisk, unblindingRiskLevel, requestPayManagerUserName, lineOfBusiness, courtyardArea, userName, date } = searchParams;
        const { curRole } = sessionStorage;
        const showExportButton = curRole !== 'CRC';
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        const areaOption = areaList.map(d => <Option key={d.investigationAreaId} value={String(d.investigationAreaId)}>{d.investigationAreaName}</Option>);
        const diseaseOption = diseaseList.map(d => <Option key={d.diseaseId} value={String(d.diseaseId)}>{d.diseaseName}</Option>);
        const CourtyardAreaOptions = CourtyardAreaList.map(i => <Option key={i.hospitalId}>{i.courtyardArea}</Option>)
        const { MonthPicker } = DatePicker;
        return (
            <div className="filter-bar">
                <div className="form-item">
                    <label className="ui-label">时间</label>
                    <MonthPicker
                        format={'YYYY-MM'}
                        value={searchParams.date ? moment(searchParams.date) : null}
                        allowClear={false}
                        placeholder="选择年月"
                        style={{ width: 110 }}
                        disabledDate={this.disabledDate}
                        onChange={this.handleMonthChange}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">医院官方名称</label>
                        <SearchRetrieve
                            keyword="hospitalName"
                            style={{ width: 200 }}
                            placeholder="输入医院名称检索"
                            value={hospitalMainName}
                            params={{ limit: 10, offset: 1 }}
                            url={API_URL.hospital.queryHospitalMainList}
                            config={{ id: 'hospitalMainId', name: 'hospitalMainName'}}
                            onChange={value => this.hospitalSelectChange(value, 'hospital')}
                        />
                </div>
                <div className="form-item">
                    <label className="ui-label">院区</label>
                        <Select
                            mode='multiple'
                            filterOption={false}
                            onSearch={this.queryCourtyardAreaList}
                            style={{ width: 180 }}
                            placeholder="请选择"
                            disabled={ !needCourtyardArea || !hospitalMainId } //本无院区，禁止填入；本有院区，且医院信息已填，允许填入
                            value={courtyardArea}
                            onChange={value => this.courtyardAreaSelectChange(value, 'courtyardArea')}
                        >
                            {CourtyardAreaOptions}
                        </Select>
                </div>
                <div className="form-item">
                    <label className="ui-label">科室</label>
                    <Input
                        placeholder="请输入"
                        value={departmentName}
                        onChange={e => this.handleInputChange(e, 'departmentName')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item" style={{ height: 30 }}>
                    <label className="ui-label">区域/城市</label>
                    <SelectProvince areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} />
                </div>
                <div className="form-item">
                    <label className="ui-label">有无中心药房</label>
                    <Select
                        allowClear={true}
                        style={{ width: 80 }}
                        onChange={(value) => this.handleSelectChange(value, 'centerPharmacy')}
                        value={centerPharmacy}
                        placeholder="请选择"
                    >
                        <Option value="true">有</Option>
                        <Option value="false">无</Option>
                    </Select>
                </div>
                {!crcFlag && <div className="form-item">
                    <label className="ui-label">有无破盲风险</label>
                    <Select
                        allowClear={true}
                        style={{ width: 80 }}
                        onChange={(value) => this.handleSelectChange(value, 'unblindingRisk')}
                        value={unblindingRisk}
                        placeholder="请选择"
                    >
                        <Option value="true">有</Option>
                        <Option value="false">无</Option>
                    </Select>
                </div>}
                {!crcFlag && <div className="form-item">
                    <label className="ui-label">破盲风险等级</label>
                    <Select
                        allowClear={true}
                        style={{ width: 80 }}
                        onChange={(value) => this.handleSelectChange(value, 'unblindingRiskLevel')}
                        value={unblindingRiskLevel}
                        placeholder="请选择"
                    >
                        <Option value="HIGH">高</Option>
                        <Option value="MIDDLE">中</Option>
                        <Option value="LOW">低</Option>
                    </Select>
                </div>}
                {!crcFlag && <div className="form-item">
                    <label className="ui-label">项目领域</label>
                    <Select
                        allowClear={true}
                        style={{ width: 120 }}
                        onChange={(value) => this.handleSelectChange(value, 'investigationAreaId')}
                        value={investigationAreaId}
                        placeholder="请选择"
                    >
                        {areaOption}
                    </Select>
                </div>}
                {!crcFlag && <div className="form-item">
                    <label className="ui-label">疾病</label>
                    <Select
                        allowClear={true}
                        style={{ width: 150 }}
                        onChange={(value) => this.handleSelectChange(value, 'diseaseId')}
                        disabled={!investigationAreaId}
                        value={diseaseId}
                        placeholder="请选择"
                    >
                        {diseaseOption}
                    </Select>
                </div>}
                <div className="form-item">
                    <label className="ui-label">是否为自己负责的医院</label>
                    <Select
                        allowClear={true}
                        style={{ width: 80 }}
                        onChange={(value) => this.handleSelectChange(value, 'isMyResponsibleHospital')}
                        value={isMyResponsibleHospital}
                        placeholder="请选择"
                    >
                        <Option value="1">是</Option>
                        <Option value="0">否</Option>
                    </Select>
                </div>
                {
                        fp.contains(curRole, ['CRCM', 'CRCC']) &&
                        <div className="search-item">
                            <label className="ui-label">是否为自己区域内的医院</label>
                            <Select
                                allowClear={true}
                                style={{ width: 80 }}
                                onChange={(value) => this.handleSelectChange(value, 'cityManagerFilter')}
                                value={cityManagerFilter}
                                placeholder="请选择"
                            >
                                <Option value="1">是</Option>
                                <Option value="0">否</Option>
                            </Select>
                        </div>
                    }
                <div className="form-item">
                    <label className="ui-label">是否为自己负责的科室</label>
                    <Select
                        allowClear={true}
                        style={{ width: 80 }}
                        onChange={(value) => this.handleSelectChange(value, 'isMyResponsibleDepartment')}
                        value={isMyResponsibleDepartment}
                        placeholder="请选择"
                    >
                        <Option value="1">是</Option>
                        <Option value="0">否</Option>
                    </Select>
                </div>
                {!crcFlag && <div className="form-item">
                    <label className="ui-label">与津石是否有合作</label>
                    <Select
                        allowClear={true}
                        style={{ width: 80 }}
                        onChange={(value) => this.handleSelectChange(value, 'isCooperation')}
                        value={isCooperation}
                        placeholder="请选择"
                    >
                        <Option value="1">是</Option>
                        <Option value="0">否</Option>
                    </Select>
                </div>}
                <div className="form-item">
                    <label className="ui-label">科室leader</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 130 }}
                        placeholder="输入姓名/工号检索"
                        value={userName}
                        params={{ limit: 20 }}
                        url={API_URL.team.userlist}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={option => this.handleUserChange(option, 'user')}
                    />
                </div>
                {!crcFlag && <div className="form-item">
                    <label className="ui-label">是否从中心请款</label>
                    <Select
                        allowClear={true}
                        style={{ width: 80 }}
                        onChange={(value) => this.handleSelectChange(value, 'isRequestFromSite')}
                        value={isRequestFromSite}
                        placeholder="请选择"
                    >
                        <Option value="1">是</Option>
                        <Option value="0">否</Option>
                    </Select>
                </div>}
                <div className="form-item">
                    <label htmlFor="" className="ui-label">科室请款负责人</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 130 }}
                        placeholder="输入姓名/工号检索"
                        value={requestPayManagerUserName}
                        params={{ limit: 20 }}
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={option => this.handleUserChange(option, 'requestPayManagerUser')}
                    />
                </div>
                {!crcFlag && <div className="form-item">
                    <label htmlFor="" className="ui-label">业务线</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{width: 120}}
                        value={lineOfBusiness}
                        onChange={value => this.handleSelectChange(value, 'lineOfBusiness')}
                    >
                        {businessOption}
                    </Select>
                </div>}
                {!crcFlag && <div className="form-item">
                    <label htmlFor="" className="ui-label">执行业务线二级分类</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{width: 120}}
                        disabled={!lineOfBusiness}
                        value={searchParams.secondLineName}
                        onChange={value => this.handleSelectChange(value, 'secondLineName')}
                    >
                        {secondLineOption}
                    </Select>
                </div>}
                <div className="form-item">
                    { isAdd && <Button type="primary" onClick={() => this.props.update({}, 'add')}>添加</Button> }
                    { !crcFlag && <Button
                        type="primary"
                        style={{ background: '#62cf96', border: '1px solid #00a854' }}
                        onClick={() => this.props.showCommentLog(true)}
                    >点评日志</Button>}
                    {
                        showExportButton &&
                        <Button type="primary" onClick={() => this.props.export(searchParams)}>导出</Button>
                    }
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => (
    {
        feedBack: state.departmentState.feedBack,
        searchParams: state.departmentState.searchParams,
    }
)

export default connect(mapStateToProps, null)(Filter);


// WEBPACK FOOTER //
// ./src/components/hospital/departmentInfo/Filter.js